/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ExecuteNotebookCodeInput {
  /**
  * Python code to execute in the notebook kernel
  */
  'code': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "code",
      "baseName": "code",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ExecuteNotebookCodeInput.attributeTypeMap;
  }

  public constructor() {
  }
}

